import React from "react";
import { Map } from "immutable";
import T from "prop-types";
import { withSalesOrder } from "MODULES/SalesOrders/decorators";
import {
  translateProps,
  toggleSwitch,
  renderIf
} from "MODULES/shared/decorators";
import { DropDownItem } from "MODULES/shared/components/DropDown";
import { CONSIGNMENT, EMA } from "MODULES/Receiving/constants";
import { submitErrorMsgs } from "MODULES/shared/components/Forms/form";
import { toastr } from "react-redux-toastr";
import { toSentence } from "LIB/formatters/text";
import api from "APP_ROOT/api";
import { ID } from "APP_ROOT/constants";
import Reason from "./Reason";

export function Cancel({ salesOrder, cancel, cancelling, open, close }) {
  return (
    <DropDownItem onClick={open}>
      <i className="fa fa-fw fa-ban" />
      &nbsp;Cancel Line Item
      <Reason
        salesOrder={salesOrder.toJS()}
        visible={cancelling}
        onSubmit={cancel}
        close={close}
      />
    </DropDownItem>
  );
}

Cancel.propTypes = {
  cancel: T.func.isRequired,
  cancelling: T.bool.isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired,
  salesOrder: T.instanceOf(Map)
};

const withCancel = translateProps(
  ({ lineItem, salesOrder, refresh, expireLineItems, close }) => ({
    cancel: (reason, sendEmail) =>
      api.salesOrders.lineItems
        .cancel(lineItem.id, reason, sendEmail)
        .then(() =>
          refresh(salesOrder.get(ID)).then(() => {
            expireLineItems();
            close();
          })
        )
        .catch(submitErr => {
          if (submitErr && submitErr.errors) {
            const msg = toSentence(submitErrorMsgs(submitErr.errors));
            toastr.error("Error", msg);
          } else {
            throw submitErr;
          }
        })
  })
);

const meetsCancellationCriteria = renderIf(
  ({
    lineItem: { cancelled, inventory: { consignment_type: consignmentType } }
  }) => !cancelled && ![EMA, CONSIGNMENT].includes(consignmentType)
);

export default withSalesOrder(
  meetsCancellationCriteria(toggleSwitch("cancelling")(withCancel(Cancel)))
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/Cancel.jsx